import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { 
  GetDeffectPositionsRequest, GetDeffectPositionsResponse, 
  PostVisualDamageRequest, PostVisualDamageResponse, 
  GetVisualDamageListRequest, GetVisualDamageListResponse, 
  GetVisualDamageCountRequest, GetVisualDamageCountResponse, 
  GetVisualDamageInfoRequest, GetVisualDamageInfoResponse 
} from '../models/visual-deffects.models';

@Injectable({
  providedIn: 'root'
})
export class VisualDeffectsService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) {
    this.apiUrl = this.configService.getConfig().apiBaseUrl;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private getQueryParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  }

  getDeffectPositions(request: GetDeffectPositionsRequest): Observable<GetDeffectPositionsResponse> {
    return this.http.get<GetDeffectPositionsResponse>(`${this.apiUrl}/VisualDeffects/GetDeffectPositions`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }

  postVisualDamage(request: PostVisualDamageRequest): Observable<PostVisualDamageResponse> {
    return this.http.post<PostVisualDamageResponse>(`${this.apiUrl}/VisualDeffects/PostVisualDamage`, request, { 
      headers: this.getHeaders() 
    });
  }

  getVisualDamageList(request: GetVisualDamageListRequest): Observable<GetVisualDamageListResponse> {
    return this.http.get<GetVisualDamageListResponse>(`${this.apiUrl}/VisualDeffects/GetVisualDamageList`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }

  getVisualDamageCount(request: GetVisualDamageCountRequest): Observable<GetVisualDamageCountResponse> {
    return this.http.get<GetVisualDamageCountResponse>(`${this.apiUrl}/VisualDeffects/GetVisualDamageCount`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }

  getVisualDamageInfo(request: GetVisualDamageInfoRequest): Observable<GetVisualDamageInfoResponse> {
    return this.http.get<GetVisualDamageInfoResponse>(`${this.apiUrl}/VisualDeffects/GetVisualDamageInfo`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }
}